/*
 *扫码登录
*/
import React from 'react'
import './login.less'
import api from '../../api/api'
import {API_CONFIG} from '../../api/config.js'
import { Icon, message } from 'antd';
export default class Smdl extends React.Component {
    state = {
        code_img: '',
        uuid: '',
        login_type: 0,
    }
    componentDidMount() {
        this.getQrCode();
    }
    
    componentWillUnmount(){
        clearInterval(this.timer)
    }

    UNSAFE_componentWillReceiveProps(nexprops) {
        if(nexprops.tabindex === '1') {
            clearInterval(this.timer)
        } else{
            this.getQrCode();
        }
    }
    getQrCode = () => {
        api.get_qr_code({}).then(res => {
            console.log(res);
            if (res.code === 0) {
                this.setState({ 
                    code_img: res.content.qrcode_img, 
                    uuid: res.content.qrcode_uuid,
                    login_type: 0
                },()=>{
                    this.timer = setInterval(() => {
                        this.onSucessLogin(this.timer)
                    }, 1500)
                })

            }
        })
    }
    onSucessLogin= (timer)=>{
            api.sso_qr_code_login({ uuid: this.state.uuid }).then(res => {
                if (res.code === 0) {
                    if(timer){
                        clearInterval(timer)
                    }
                    sessionStorage.setItem('source',res.content.source)
                    document.cookie= `${API_CONFIG.company_token}=${res.content.access_token};domain=colourlife.com;;path=/;`
                    sessionStorage.setItem('access_token', res.content.access_token);
                    api.get_user_info({
                        access_token:  sessionStorage.getItem('access_token')
                    }).then(res => {
                        this.setState({login_type:3},() => {
                            if (res.content.has_team === 2) {
                                //无团队登录成功
                                message.error('您还没有创建企业，请先去注册')
                            } else if(res.content.has_team === 1 && res.content.team.length === 1) {
                        
                                sessionStorage.setItem('team', JSON.stringify(res.content.team))
                                // 登录指定团队后台
                                api.get_company_login({
                                    access_token: sessionStorage.getItem('access_token'),
                                    corp_uuid: res.content.team[0].id,
                                    source:sessionStorage.getItem('source')
                                }).then(res=>{
                                    this.setState({grounpLoading: false})
                                    if(res.code===0) {
                                        sessionStorage.setItem('company_token',res.content.access_token)
                                        document.cookie= `cloud_token=${res.content.access_token};domain=colourlife.com;;path=/;`
                                        if(sessionStorage.getItem('market_url')){
                                            let market_url = sessionStorage.getItem('market_url')
                                            window.location.href=`${market_url}`
                                        } else {
                                            window.location.href=`${API_CONFIG.yun_base}`
                                        }
                                    }
                                })
                            } else if (res.content.has_team === 1 && res.content.team.length > 1) {
                                //有团队大于1
                                sessionStorage.setItem('team',JSON.stringify(res.content.team));
                                this.props.onSucessLogin(true, res.content.team )
                            }
                        })
                    })
                    
                  
                }
                // 非法的请求操作
                if(res.code===5013){
                    if(timer){                        //11月/24日处理选择企业页面弹出非法的操作
                        clearInterval(timer)
                    }
                    window.history.go(0)
                }
                //二维码已过期
                if (res.code === 5016) {
                    if(timer){
                        clearInterval(timer)
                    }
                    this.setState({login_type: 2})
                }
                // 二维码未扫描
                if (res.code === 5017) {
                   
                }
                //二维码已扫描
                if (res.code === 5018) {
                    this.setState({login_type: 1})
                }
            })
        
      
     
        
    }
    render() {
        const {  login_type } = this.state
        const gettitle=()=>{
            if(login_type===0){
                return '打开彩管家，扫一扫登录'
            }else if(login_type===1){
                return (
                    <div>
                        <p>扫码成功，请在手机端完成操作</p>
                        <p className='warning'>请勿刷新页面</p>
                    </div>
                    )
            }else if(login_type===2){
                return (
                    <div>
                        <p>二维码已失效</p>
                        <p className='reload' onClick={this.getQrCode} >点击刷新</p>
                    </div>
                )
            } else if(login_type===3){
                return '正在登录…'
            }
        }
        return (<div className='smdl'>
            {/* 扫码登录 */}
            <div className="img-wrap">
                <img src={this.state.code_img} alt="" />
                {(login_type===1||login_type===2||login_type===3)?(
                    <div>
                    <div className="mask"></div>
                    {login_type === 1 ?
                     <div className='home_icon_success'></div>:
                        (
                            login_type === 2 ?
                            <div className='home_icon_shuaxin'　onClick={this.getQrCode}></div>:
                            <div className='login_icon_loading'></div>
                        )
                    }
                    </div>
                ):''}
            </div>
            <div className='title-wrap'>{gettitle()}</div>
        </div>)
    }
}


// WEBPACK FOOTER //
// ./src/pages/login/smdl.jsx